const EffectiveContractNotificationSnackbar= {
  namespaced: true,
  state: ()=>({
    snackbar: false,

    text: "",

    timeout: 2000,

    color: "",
  }),

  mutations: {

    setSnackbar(state, flag) {
      state.snackbar = flag;
    },

    setParams(state, parameters) {
      state.text = parameters?.text || state.text;
      state.timeout = parameters?.timeout || state.timeout;
      state.color = parameters?.color || state.color;
    },

    setSuccessParams(state) {
      state.text = "Выполнено успешно";
      state.timeout = 2000;
      state.color = "teal darken-2";
    },

    setErrorParams(state) {
      state.text = "Ошибка сервера";
      state.timeout = 2000;
      state.color = "orange darken-2";
    },

    resetParameters(state) {
      state.text = "";
      state.timeout = 2000;
      state.color = "";
    }

  },

  actions: {
    setSnackbarAction({state, commit}, {flag, parameters}) {
      commit('setParams', parameters);
      commit('setSnackbar', flag);
    },

    successSnackbarAction({commit}) {
      commit('setSuccessParams');
      commit('setSnackbar', true);
    },

    errorSnackbarAction({commit}) {
      commit('setErrorParams');
      commit('setSnackbar', true);
    },

    toggleSnackbarAction({state, commit}) {
      commit('resetParameters');
      commit('setSnackbar', !state.snackbar);
    }
  },
}

export default EffectiveContractNotificationSnackbar